// Mock data for PROTAXESPLUS website

export const companyInfo = {
  name: "PROTAXESPLUS",
  email: "Infos@protaxesplus.ca",
  phone: "(514) 660-4711",
  address: "6500 route Transcanadienne, Saint-Laurent, H4T 1X4",
  suite: "(Suite 120-D)",
  hours: "Lundi-Vendredi : 09H30 - 18H00 (Samedi sur Rendez-Vous)"
};

export const services = [
  {
    id: 1,
    title: "Déclarations de revenus",
    icon: "FileText",
    image: "https://customer-assets.emergentagent.com/job_accountax-portal/artifacts/qy0jlp7w_Declarartion.png",
    description: "Production de déclarations de revenus pour particuliers, travailleurs autonomes et petites entreprises.",
    details: [
      "Déclarations de revenus personnelles",
      "Déclarations pour travailleurs autonomes",
      "Déclarations pour petites entreprises"
    ]
  },
  {
    id: 2,
    title: "Comptabilité",
    icon: "Calculator",
    image: "https://customer-assets.emergentagent.com/job_taxsmart-11/artifacts/rl76km48_comptabilit%C3%A9.png",
    description: "Services de comptabilité complète adaptés à vos besoins d'entreprise.",
    details: [
      "Gestion des comptes fournisseurs et clients",
      "Rapports financiers mensuels",
      "Conciliation bancaire"
    ]
  },
  {
    id: 3,
    title: "Tenue de livres",
    icon: "BookOpen",
    image: "https://customer-assets.emergentagent.com/job_taxsmart-11/artifacts/en1jtxx9_Tenue%20de%20livre.png",
    description: "Tenue de livres comptables professionnelle pour maintenir vos finances en ordre.",
    details: [
      "Saisie des transactions quotidiennes",
      "Classification des dépenses",
      "Gestion des factures",
      "Suivi des revenus et dépenses",
      "Rapports personnalisés"
    ]
  },
  {
    id: 4,
    title: "Gestion de la paie",
    icon: "DollarSign",
    image: "https://customer-assets.emergentagent.com/job_taxsmart-11/artifacts/uqa1vi0h_Paie%20.png",
    description: "Gestion complète de la paie pour assurer le paiement ponctuel de vos employés.",
    details: [
      "Calcul et traitement de la paie",
      "Déclarations de source",
      "Relevés d'emploi",
      "Conformité aux normes",
      "Dépôt direct"
    ]
  }
];

export const pricing = [
  {
    id: 1,
    category: "Déclarations de revenus",
    plans: [
      {
        name: "Travailleur autonome",
        price: "À partir de 150$",
        features: [
          "Revenus d'entreprise",
          "Déductions d'affaires",
          "TPS/TVQ",
          "Support prioritaire"
        ]
      },
      {
        name: "Particulier simple",
        price: "À partir de 80$",
        features: [
          "T4 et relevé 1",
          "Crédits d'impôt de base",
          "Production électronique",
          "Support par téléphone"
        ],
        popular: true
      },
      {
        name: "Petite entreprise",
        price: "Sur demande",
        features: [
          "Déclarations corporatives",
          "Rapports financiers",
          "Consultation illimitée",
          "Support téléphonique"
        ]
      }
    ]
  },
  {
    id: 2,
    category: "Services mensuels",
    plans: [
      {
        name: "Tenue de livres",
        price: "Tarif horaire sur demande",
        features: [
          "Saisie des transactions",
          "Conciliation bancaire",
          "Rapports mensuels",
          "Support par courriel"
        ]
      },
      {
        name: "Comptabilité complète",
        price: "À partir de 200$/mois",
        features: [
          "Tenue de livres incluse",
          "Documents financiers mensuels",
          "Déclaration des taxes de vente",
          "Déclarations corporatives",
          "Consultation mensuelle",
          "Support prioritaire"
        ],
        popular: true
      },
      {
        name: "Gestion de la paie",
        price: "Tarifs sur demande",
        features: [
          "Traitement de la paie",
          "Déclarations de source",
          "Dépôt direct",
          "Relevés d'emploi",
          "Support téléphonique"
        ]
      }
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "Quels documents dois-je fournir pour ma déclaration de revenus?",
    answer: "Vous devez fournir tous vos feuillets de revenus (T4, T5, relevé 1, etc.), les reçus de dépenses déductibles, les relevés de REER/CELIAPP, et tout autre document pertinent à votre situation fiscale. Nous vous fournirons une liste complète lors de notre première rencontre."
  },
  {
    id: 2,
    question: "Quand dois-je produire ma déclaration de revenus?",
    answer: "Pour les particuliers, la date limite est le 30 avril. Pour les travailleurs autonomes, c'est le 15 juin, mais les impôts dus doivent être payés avant le 30 avril. Pour les entreprises, les dates varient selon la structure juridique."
  },
  {
    id: 3,
    question: "Offrez-vous des services de consultation fiscale?",
    answer: "Oui, nous offrons des services de planification et consultation fiscale pour vous aider à optimiser votre situation fiscale tout au long de l'année. Contactez-nous pour planifier une consultation."
  },
  {
    id: 4,
    question: "Comment se déroule la gestion de la paie?",
    answer: "Nous nous occupons du calcul complet de la paie, des déductions à la source, des déclarations gouvernementales, et du versement des salaires par dépôt direct. Vous n'avez qu'à nous fournir les heures travaillées et nous gérons le reste."
  },
  {
    id: 5,
    question: "Vos services sont-ils adaptés aux petites entreprises?",
    answer: "Absolument! Nous sommes spécialisés dans les services pour petites entreprises et travailleurs autonomes. Nos forfaits sont flexibles et s'adaptent à la taille et aux besoins de votre entreprise."
  },
  {
    id: 6,
    question: "Comment puis-je vous transmettre mes documents?",
    answer: "Vous pouvez nous transmettre vos documents par courriel sécurisé (SecureExchange), ou en personne à notre bureau. Nous acceptons les documents numérisés ou photographiés."
  },
  {
    id: 7,
    question: "Combien de temps faut-il pour traiter ma déclaration?",
    answer: "Les délais de traitement varient selon la complexité de votre dossier. En général, les déclarations simples sont traitées dans un délai de 2 à 3 jours ouvrables, tandis que les dossiers plus complexes nécessitent 5 à 7 jours ouvrables. Pour les déclarations transmises en ligne, le délai de traitement est habituellement de 1 à 2 semaines. Les déclarations de base peuvent, quant à elles, être complétées directement lors du rendez-vous, dans le temps qui y est alloué (généralement une heure)."
  },
  {
    id: 8,
    question: "Que se passe-t-il si je reçois un avis de cotisation avec des questions?",
    answer: "Nous offrons un service de suivi complet. Si vous recevez une demande de renseignements ou un avis de nouvelle cotisation, nous vous aiderons à y répondre et à résoudre tout problème avec les autorités fiscales."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dubois",
    role: "Travailleuse autonome",
    content: "Service exceptionnel! PROTAXESPLUS a simplifié ma vie fiscale et m'a fait économiser considérablement. Je recommande fortement!",
    rating: 5
  },
  {
    id: 2,
    name: "Jean Tremblay",
    role: "Propriétaire de PME",
    content: "Équipe professionnelle et efficace. Ils gèrent notre paie et notre comptabilité avec précision. Un vrai partenaire d'affaires.",
    rating: 5
  },
  {
    id: 3,
    name: "Sophie Martin",
    role: "Particulier",
    content: "Excellente expérience! Rapide, précis et à l'écoute. Mon dossier a été traité rapidement et j'ai reçu mon remboursement en un temps record.",
    rating: 5
  }
];
